module.exports = __webpack_public_path__ + "img/inicio.32173fa7.svg";